// src/components/HomePage.tsx

const HomePage = () => {
  return (
    <div className="text-4xl font-bold min-h-screen text-center px-6 relative">
      <div className="absolute top-4 left-4">
        <img
          src="/logo.png"
          alt="iKnowly Logo"
          className="w-24 h-auto"
        />
      </div>

      <div className="flex flex-col items-center justify-center min-h-screen">
        <p className="text-lg mt-16">🚫 You are not authorized to enter the iknowly room.🔐</p>
        
        <a
          href="http://iknowly.com/"
          className="mt-4 text-blue-500 hover:underline"
        >
          Visit iknowly
        </a>
      </div>
    </div>
  );
};

export default HomePage;
